import { render, staticRenderFns } from "./regent.vue?vue&type=template&id=e412cf7c&"
import script from "./regent.vue?vue&type=script&lang=js&"
export * from "./regent.vue?vue&type=script&lang=js&"
import style0 from "./regent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports